import $ from 'jquery';

class MaRSResearchInsight {

  // 1. describe and create/initiate object
  constructor() {
    setTimeout(this.LoadActiveResults(), 750);
    this.resultsDiv = $(".allResearchInsight__Results");
    this.showButton = $(".allResearchInsight__link");
    this.filterSelect = $(".allResearchInsight__filter-child li");
    this.searchField = $("#venture-search");
    this.loadMoreButton = $(".allResearchInsight__load a");
    this.postsPerPage = 9;
    this.screenWidth = $(window).width();
    this.events();
    this.isSpinnerVisible = false;
    this.isOverlayOpen = false;
    this.previousValue;
    this.typingTimer;
    this.loadInfo;
    this.body = $('body');
  }

  // 2. events
  events() {
    this.loadMoreButton.on("click", this.getMoreResults.bind(this));
    this.searchField.on("keyup", this.typingLogic.bind(this));
    this.filterSelect.on("click", this.filterLogicSector.bind(this));
  }

  // 3. methods (function, action...)
  typingLogic() {
    if (this.searchField.val() != this.previousValue) {
      clearTimeout(this.typingTimer);
      $(".mtoggle li.active span").html($(".mtoggle li.active span").attr("data-hold"));

      if (this.searchField.val()) {
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
          this.isSpinnerVisible = true;
        }
        this.typingTimer = setTimeout(this.getResults.bind(this), 750);
      } else {

        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
          this.isSpinnerVisible = true;
        }
        this.typingTimer = setTimeout(this.getResults.bind(this), 750);
        this.isSpinnerVisible = true;
      }
    }
    this.previousValue = this.searchField.val();
  }


  filterLogicSector(e) {
    if ($(this)) {
      let curTarget = e.currentTarget;
      let target, slug = e.target;

      target = slug.getAttribute('data-id');
      let attrType = curTarget.parentElement.getAttribute('data-pane');

      if (target) {
        clearTimeout(this.typingTimer);
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
          <div class="sk-double-bounce">
            <div class="sk-child sk-double-bounce1"></div>
            <div class="sk-child sk-double-bounce2"></div>
          </div>`);
          this.isSpinnerVisible = true;
        }
        this.searchField.val("");
        this.typingTimer = setTimeout(this.getFilterResults(attrType, target), 750);


        setTimeout(() => {
          $(curTarget).parent().parent().find('span').html(curTarget.innerHTML);
        }, 100);
      } else if (!target && !this.isOpened) {

        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
          <div class="sk-double-bounce">
            <div class="sk-child sk-double-bounce1"></div>
            <div class="sk-child sk-double-bounce2"></div>
          </div>`);
          this.isSpinnerVisible = true;
        }
        this.searchField.val("");
        this.typingTimer = setTimeout(this.getFilterResults(attrType, target), 750);
        this.isSpinnerVisible = true;
      }
    }
  }


  getResults() {
    if ($(".allResearchInsight__Results").length) {
      $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/insights?term=' + this.searchField.val() + '&page=1', (results) => {
        let currentPage = results.current_page;
        this.resultsDiv.html(`   
            ${results.researchInfo.length ? '<div class="row no-gutters allResearchInsight__row">' : '<p>No Research information matches that search.</p>'}
            ${results.researchInfo.map(item => `<a href="${item.permalink}" 
              class="col col-12 col-md-6 col-lg-4 allResearchInsight__link">
              <span class="allResearchInsight__subtitle">${item.serviceArea ? item.serviceArea : item.service.post_title}</span>
              <h3>${item.title}</h3>
              
              <i class="allServices__arrow"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
              <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
              <path d="M1 5h42M40 1l4 4-4 4"/></g></svg></i>
              
              </a>`).join('')}
          ${results.researchInfo.length ? '</div>' : ''}     
      `);
        this.isSpinnerVisible = false;
        this.searchField.val() ? this.loadMoreButton.attr("data-url", `term=${this.searchField.val()}&page=2`) : '';
        `${(results.max_pages == currentPage || results.max_pages < currentPage) ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
      }).fail(function (jqXHR, textStatus, error) {
      });
    }
  }


  getFilterResults(type, sectorValue) {
    $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/insights?' + type + '=' + sectorValue + '&page=1', (results) => {
      let currentPage = results.current_page;
      this.resultsDiv.html(`
            ${results.researchInfo.length ? '<div class="row no-gutters allResearchInsight__row">' : '<p>No Research information matches that search.</p>'}
            ${results.researchInfo.map(item => `<a href="${item.permalink}" 
              class="col col-12 col-md-6 col-lg-4 allResearchInsight__link">
              <span class="allResearchInsight__subtitle">${item.serviceArea ? item.serviceArea : item.service.post_title}</span>
              <h3>${item.title}</h3>
              
              <i class="allServices__arrow"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
              <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
              <path d="M1 5h42M40 1l4 4-4 4"/></g></svg></i>
              
              </a>`).join('')}
          ${results.researchInfo.length ? '</div>' : ''}
       
      `);
      this.isSpinnerVisible = false;
      // sectorValue ? this.loadMoreButton.attr("data-url", `sector=${sectorValue}&page=2`) : this.loadMoreButton.attr("data-url", `term=${sectorValue}&page=2`);
      this.loadMoreButton.attr("data-url", `${type}=${sectorValue}&page=2`);
      `${(results.max_pages == currentPage || results.max_pages < currentPage) ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
    }).fail(function(jqXHR, textStatus, error) {
    });
  }


  LoadActiveResults() {

    if ($(".allResearchInsight__Results").length) {
      $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/insights?sector=&page=1', (results) => {
        let currentPage = results.current_page;
        this.resultsDiv.html(`
          ${results.researchInfo.length ? '<div class="row no-gutters allResearchInsight__row">' : '<p>No Research information matches that search.</p>'}
            ${results.researchInfo.map(item => `<a href="${item.permalink}" class="col col-12 col-md-6 col-lg-4 allResearchInsight__link">
              <span class="allResearchInsight__subtitle">${item.serviceArea ? item.serviceArea : item.service.post_title}</span>
              <h3>${item.title}</h3>
              
              <i class="allServices__arrow"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
              <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
              <path d="M1 5h42M40 1l4 4-4 4"/></g></svg></i>
              
              </a>`).join('')}
          ${results.researchInfo.length ? '</div>' : ''}
      `);
        this.isSpinnerVisible = false;
        this.loadMoreButton.attr("data-url", `term=${this.searchField.val()}&page=${parseInt(currentPage) + 1}`);
        `${results.max_pages == currentPage ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
      }).fail(function (jqXHR, textStatus, error) {
      });
    }
  }


  getMoreResults(e) {
    e.preventDefault();
    this.loadInfo = this.loadMoreButton.attr("data-url");

    let params = new URLSearchParams(this.loadInfo);
    params.delete('page');

    
    if (!this.isSpinnerVisible) {
      this.resultsDiv.append(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
      this.isSpinnerVisible = true;
    }

    $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/insights?' + this.loadInfo, (results) => {
      let currentPage = results.current_page;
      this.resultsDiv.append(`   
            ${results.researchInfo.length ? '<div class="row no-gutters allResearchInsight__row">' : '<p>No Research information matches that search.</p>'}
            ${results.researchInfo.map(item => `<a href="${item.permalink}" 
              class="col col-12 col-md-6 col-lg-4 allResearchInsight__link">
              <span class="allResearchInsight__subtitle">${item.serviceArea ? item.serviceArea : item.service.post_title}</span>
              <h3>${item.title}</h3>
              
              <i class="allServices__arrow"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
              <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
              <path d="M1 5h42M40 1l4 4-4 4"/></g></svg></i>
              
              </a>`).join('')}
          ${results.researchInfo.length ? '</div>' : ''}
      `);
      $('.sk-double-bounce').remove();
      this.isSpinnerVisible = false;
      // this.loadMoreButton.attr("data-url", `term=${this.searchField.val()}&page=${parseInt(currentPage) + 1}`);
      this.loadMoreButton.attr("data-url", `${params.toString()}&page=${parseInt(currentPage) + 1}`);

      `${results.max_pages == currentPage ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
    }).fail(function(jqXHR, textStatus, error) {
    });
  }

}

export default MaRSResearchInsight;